// BoardSearch: the head of an empty workspace's board, on the board's own
// ground: the workspace's one search as the board's finder (the board's only
// frame, at its very top), holding what the search reaches. Where the page
// holds a place for the box (`host`, kept at the top of the page as it
// scrolls), the box stands there and the board keeps its room. A search here
// (or in the sidebar: the same search) redraws the board under it; a search
// worth keeping starts a workspace of its own.
//
// It keeps to the board's three kinds of text: the eyebrow for labels, 12px
// for names and sentences, 11px for counts and asides; the finder's field is
// the one larger line, as the thing to start from.
import { memo, useMemo } from "react";
import { createPortal } from "react-dom";
import SearchPalette, { FINDER_BOX_H } from "./SearchPalette.jsx";
import { useWorkspaceSearch } from "../lib/workspaceSearch.js";

// The head's height on the board, for the board to lay its cards under it.
export const SEARCH_H = FINDER_BOX_H;

// Redrawn only when what it says changes, not as the board under it is pointed at.
function BoardSearch({ facts, reached = null, kinds, notice, clauseFor, metricsData, range, width, finderWidth, finderHeight, onPreview, onStart, startLabel, startHint, host = null }) {
  const [text, setText] = useWorkspaceSearch();
  const m = metricsData;
  const sessions = facts.sessions;
  // Counted as the sessions beside them are, over all the search reaches:
  // where the board is drawn from the newest of them, from where review left
  // every one (`reached`).
  const drawnMet = useMemo(() => sessions.filter((s) => s.outcome === "met").length, [sessions]);
  const drawnFlagged = useMemo(() => sessions.filter((s) => s.outcome && s.outcome !== "none" && s.outcome !== "met").length, [sessions]);
  const met = reached ? reached.met : drawnMet;
  const flagged = reached ? reached.not_verified + reached.not_met + reached.set_aside : drawnFlagged;
  // What the search reaches, said in its box once the board's reading of it
  // has landed (its flags are the board's); until then, that it is reading.
  const reading = facts.status === "loading" || !!facts.stale;
  const reach = m && !reading ? { sessions: m.sessions, machines: m.endpoints, requests: m.requests, met, flagged } : null;
  const finder = (
    <div className="relative z-[3]" aria-busy={host && (!m || reading) ? "true" : undefined}>
      <SearchPalette query={text} setQuery={setText} kinds={kinds} sessions={sessions} reach={reach} reading={reading} notice={notice} clauseFor={clauseFor} range={range} width={width} finderWidth={finderWidth} finderHeight={finderHeight} onPreview={onPreview} onStart={onStart} startLabel={startLabel} startHint={startHint} />
    </div>
  );

  return (
    <div className="absolute inset-x-0 top-0 flex flex-col" style={{ height: SEARCH_H }} aria-busy={!m || reading ? "true" : undefined} data-board-search="">
      {host ? <div className="shrink-0" style={{ height: FINDER_BOX_H }} aria-hidden="true" data-board-search-room="" /> : finder}
      {host ? createPortal(finder, host) : null}
    </div>
  );
}

export default memo(BoardSearch);
